module.exports = __webpack_public_path__ + "assets/apple-touch-icon-57-devel-c1575a.png";